/**
 *
 *  Confirm Email page
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 20/07/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Title, Meta } from "react-meta-elements";
import { useAppState } from "../../state";
import { useRegion } from "../../context/RegionProvider";
import useLatest from "../../hooks/useLatest/useLatest";

// Components
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import ScrollToTopOnMount from "../ScrollToTopOnMount/ScrollToTopOnMount";

// Icons
import CheckNiceIcon from "../../icons/CheckNiceIcon";
import BlockerIcon from "../../icons/BlockerIcon";

export default function ConfirmEmailPage() {
  const location = useLocation();
  const { region } = useRegion();

  const {
    user,
    confirmCustomerEmail,
    error,
    emailConfirmed,
    hasEmailVerificationError,
    isFetching,
  } = useAppState();

  const confirmCustomerEmailCancelablePromiseRef = useRef();

  const isFetchingLatest = useLatest(isFetching);

  useEffect(() => {
    var queryParams = location.search
      .substr(1)
      .split("&")
      .reduce(function (q, query) {
        var chunks = query.split("=");
        var key = chunks[0];
        var value = decodeURIComponent(chunks[1]);
        value = isNaN(Number(value)) ? value : Number(value);
        return (q[key] = value), q;
      }, {});

    const id = queryParams["id"];
    const code = queryParams["code"];
    const email = queryParams["email"];

    if (isFetchingLatest.current || emailConfirmed) {
      return;
    }

    if (id && code && email) {
      confirmCustomerEmail(id, email, code);
    }
  }, [emailConfirmed]);

  return (
    <div className="tbk-h-full tbk-w-full tbk-items-center md:tbk-flex md:tbk-flex-col">
      <ScrollToTopOnMount />
      <Meta
        name="description"
        content={`On-demand, in person, personal training in ${
          region === "US" ? "Los Angeles" : "London"
        }.`}
      />
      <Header behaviour="none" isLoggedIn={!!(user && user.id)} />

      <div className="tbk-relative tbk-min-h-[376px] tbk-w-full tbk-grow tbk-bg-grey-light tbk-text-center">
        <div className="tbk-container tbk-z-1 tbk-mx-auto tbk-px-2 tbk-pt-4 tbk-pb-8 lg:tbk-mt-3 lg:tbk-px-8 lg:tbk-pt-8 ">
          {emailConfirmed ? (
            <div>
              <h1 className="tbk-text-title-bold tbk-mb-4 tbk-text-grey-main">
                Your Email Has Been <br className="tbk-hidden lg:tbk-block" />
                Verified
              </h1>
              <CheckNiceIcon size={64} className="tbk-mx-auto tbk-text-green" />
            </div>
          ) : hasEmailVerificationError ? (
            <div>
              <h1 className="tbk-text-title-bold tbk-mb-4 tbk-text-grey-main">
                Email Verification Failed
              </h1>
              <BlockerIcon
                size={64}
                className="tbk-mx-auto tbk-mb-2 tbk-text-green"
              />
              {error ? (
                <p className="tbk-text-main tbk-mb-3 tbk-max-w-full tbk-text-center tbk-text-grey-main">
                  {error.message}
                </p>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
      <Footer />
    </div>
  );
}
